// components/CompanyJsonLd.tsx
export function CompanyJsonLd() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'CRYPTOCONTROLLABS LTDA',
    legalName: 'CRYPTOCONTROLLABS LTDA',
    taxID: '52.905.625/0001-04',
    url: 'https://cryptocontrol.pro/',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'AV BRIG FARIA LIMA, SALA ESC 1119 nº 1811',
      addressLocality: 'SÃO PAULO',
      addressRegion: 'SP',
      postalCode: '01452-001',
      addressCountry: 'BR',
    },
    email: 'contact@cryptocontrol.pro',
    telephone: '+55 11 96742-8387',
    sameAs: [],
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
